export const admin = {
  common: {
    loading: 'Wird geladen…',
    loadingOrganiser: 'Veranstalter wird geladen…',
    couldNotLoadEvents: 'Kurse konnten nicht geladen werden',
    noEventsAvailable: 'Keine Kurse verfügbar',
    getTickets: 'Tickets sichern',
    soldOut: 'Ausverkauft',
    free: 'Kostenlos',
    view: 'Ansehen',
    online: 'Online',
    ticketsLeft: 'Noch {remaining} übrig',
    saveEvent: 'Kurs merken',
    removeFromSaved: 'Aus Merkliste entfernen',
    datesCount: '{count} Termine',
  },
  app: {},
  organiser: {
    loadErrorTitle: 'Veranstalterinformationen konnten nicht geladen werden',
    eventsByOrganiser: 'Kurse von {organiserName}',
    noEventsBody: 'Schauen Sie bald wieder vorbei für neue Kurse.',
  },
  instancePicker: {
    title: 'Wählen Sie Ihren Kurs',
    subtitle: 'Wählen Sie einen Veranstalter, um Tickets zu durchsuchen und zu kaufen.',
    browseAllTitle: 'Alle Kurse durchsuchen',
    browseAllDescription: 'Kurse aller Veranstalter an einem Ort ansehen',
    browseEvents: 'Kurse durchsuchen',
  },
  directory: {
    loadingEvents: 'Kurse werden geladen...',
    searchPlaceholder: 'Kurse, Veranstalter, Orte durchsuchen…',
    title: 'Kursverzeichnis',
    seoTitle: 'Kursverzeichnis — Alle Kurse durchsuchen',
    seoDescription: 'Entdecken Sie Kurse von Veranstaltern auf der gesamten Plattform. Durchsuchen, filtern und Tickets sichern.',
    jsonldListName: 'Kursverzeichnis',
    jsonldListDescription: 'Kurse von mehreren Veranstaltern',
    eventsCountFromAllOne: '1 Kurs von allen Veranstaltern',
    eventsCountFromAllOther: '{count} Kurse von allen Veranstaltern',
    browseEventsFromAll: 'Kurse von allen Veranstaltern durchsuchen',
    sortUpcoming: 'Zuerst bevorstehende',
    sortPriceLowHigh: 'Preis: aufsteigend',
    sortNameAZ: 'Name A–Z',
    inPerson: 'Vor Ort',
    saved: 'Gemerkt',
    locationPlaceholder: 'Ort',
    allLocations: 'Alle Orte',
    clearFilters: 'Filter zurücksetzen ({count})',
    categoryAll: 'Alle',
    noSavedEvents: 'Keine gemerkten Kurse',
    noSavedEventsBody: 'Merken Sie Kurse, indem Sie auf das ♡ einer Kurskarte klicken.',
    noEventsFound: 'Keine Kurse gefunden',
    noEventsFoundFilteredBody: 'Versuchen Sie eine andere Suche oder setzen Sie einige Filter zurück.',
    noEventsFoundBody: 'Derzeit sind keine Kurse im Verzeichnis gelistet.',
    loadMoreEvents: 'Weitere Kurse laden',
    showingCount: 'Zeige {shown} von {total}',
    organiserNotFound: 'Veranstalter nicht gefunden',
    backToDirectory: 'Zurück zum Verzeichnis',
    upcomingEvents: 'Bevorstehende Kurse',
    eventsListedCountOne: '1 Kurs gelistet',
    eventsListedCountOther: '{count} Kurse gelistet',
    noEventsListed: 'Keine Kurse gelistet',
    noEventsListedBody: 'Dieser Veranstalter hat noch keine Kurse im Verzeichnis gelistet.',
    allEventsButton: 'Alle Kurse',
    organiserSeoTitle: '{organiserName} — Kurse',
    organiserSeoDescriptionFallback: 'Entdecken Sie bevorstehende Kurse von {organiserName}.',
  },
  ticketingEnabledGuard: {
    title: 'Ticketverkauf nicht verfügbar',
    description: 'Dieser Veranstalter bietet derzeit keinen Ticketverkauf an.',
  },
};
